const STORAGE_KEY = 'bahne:geo-country';

export default async () => {
  let country = localStorage.getItem(STORAGE_KEY);

  if (country) {
    return country;
  }

  try {
    const response: { country: string } = await fetch(
      'https://get.geojs.io/v1/ip/country.json',
    ).then((response) => response.json());

    country = response.country.toUpperCase();
    localStorage.setItem(STORAGE_KEY, country);
  } catch {
    return null;
  }

  return country;
};
